/**
 * Control Room → Plattformadminer (sak 238, trinn 2; migrering 0478).
 *
 * `GET/POST/DELETE /v1/platform/admins`. Bare for en plattformadmin; alle andre får 404. Å legge til
 * gjelder en bruker som finnes (på e-post), og gir superadmin-medlemskap i Tvitvi-organisasjonen.
 * Den siste kan ikke fjernes (`VALIDATION_FAILED` med detaljkoden `last_platform_admin`). Andre
 * detaljkoder: `user_not_found`, `already_platform_admin`.
 */
import { z } from 'zod';

export const PLATFORM_ADMIN_REFUSALS = [
  'user_not_found',
  'already_platform_admin',
  'last_platform_admin',
] as const;
export type PlatformAdminRefusal = (typeof PLATFORM_ADMIN_REFUSALS)[number];

export const platformAdminSchema = z
  .object({
    userId: z.uuid(),
    email: z.string(),
    displayName: z.string().nullable(),
    addedAt: z.iso.datetime(),
  })
  .meta({ id: 'PlatformAdmin' });

/** Alle plattformadminene, eldste først. Lista er kort (en håndfull), så den blas ikke. */
export const platformAdminListResponseSchema = z
  .object({ items: z.array(platformAdminSchema) })
  .meta({ id: 'PlatformAdminListResponse' });

export const addPlatformAdminRequestSchema = z
  .object({ email: z.string().trim().toLowerCase().pipe(z.email()) })
  .meta({ id: 'AddPlatformAdminRequest' });

export type PlatformAdmin = z.infer<typeof platformAdminSchema>;
export type PlatformAdminListResponse = z.infer<typeof platformAdminListResponseSchema>;
export type AddPlatformAdminRequest = z.infer<typeof addPlatformAdminRequestSchema>;
